<script lang="ts">
export enum TradeNavLink {
  'spot' = 'spot',
  'instantTrade' = 'portfolio',
  'futures' = 'futures',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const emit = defineEmits<{
  (e: 'link-clicked', value: TradeNavLink): void;
}>();

interface HeaderLink {
  id: TradeNavLink;
  withLozenge: boolean;
  selected: boolean;
  text: string;
  onClick: () => void;
}

const { t } = useI18n({ useScope: 'global' });
const route = useRoute();

const links = computed<Array<HeaderLink>>(() => [
  {
    id: TradeNavLink.instantTrade,
    withLozenge: false,
    selected: route.name === 'portfolio',
    text: 'Swap',
    onClick: () => emit('link-clicked', TradeNavLink.instantTrade),
  },
  {
    id: TradeNavLink.spot,
    withLozenge: true,
    selected: ['spot', 'futures'].includes(route.name as string),
    text: t('modules.header.navButtons.spot'),
    onClick: () => emit('link-clicked', TradeNavLink.spot),
  },
]);
</script>

<template>
  <div class="app-header-nav-links">
    <x-button
      v-for="link in links"
      :key="link.id"
      class="app-header-nav-links__item"
      variant="nav"
      size="lg"
      :testid="`nav-link-${link.id}`"
      :active-nav="link.selected"
      @click="link.onClick"
    >
      <div class="app-header-nav-links__text">{{ link.text }}</div>
    </x-button>
  </div>
</template>

<style lang="scss" scoped>
.app-header-nav-links {
  display: flex;
  align-items: center;

  &__item + &__item {
    margin-left: 24px;
  }

  &__lozenge {
    margin-left: 10px;
  }
}
</style>
